module.exports = __webpack_public_path__ + "img/portada_2.1cc90dfd.jpg";